import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthProvider';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import Board from './board';
import clsx from 'clsx';
import EmpresasService from '../../services/EmpresasService';
import { uniqueId } from 'lodash';
import ModalMapaConciliacao from './modal-mapa';
import RelatoriosService from '../../services/RelatoriosService';
import ModalResumo from './modal-resumo';
import ModalDashboardVertical from './modal-dashboard-vertical';

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';

function AndamentoContasResultado() {
  const { t } = useTranslation();
  const [iniciouCarregamentoTela, setIniciouCarregamentoTela] = useState<boolean>(false);

  const [empresas, setEmpresas] = useState<any[]>([]);
  const [openModalResumo, setOpenModalResumo] = useState<boolean>(false);
  const [openModalVertical, setOpenModalVertical] = useState<boolean>(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState<number>(0);
  const [carregandoEmpresa, setCarregandoEmpresa] = useState<boolean>(false);

  const [esteiras, setEsteiras] = useState<any[]>([]);
  const [esteiraSelecionada, setEsteiraSelecionada] = useState<number>(0);
  const [esteiraRealSelecionada, setEsteiraRealSelecionada] = useState<any>(null);
  const [carregandoEsteiras, setCarregandoEsteiras] = useState<boolean>(false);

  const [showModalOpcoes, setShowModalOpcoes] = useState<boolean>(false);

  const [porcentagem, setPorcentagem] = useState<number>(0);
  const [carregandoPorcentagem, setCarregandoPorcentagem] = useState<boolean>(false);
  const [etapaImportacao, setEtapaImportacao] = useState<string>('');
  const [detalhesImportacao, setDetalhesImportacao] = useState<any>(null);
  const [showDetalhesImportacao, setShowDetalhesImportacao] = useState<boolean>(false);

  const { usuario } = useAuth();
  const { classes } = useLayout();

  const onChangeEsteira = useCallback((e: any, dados: any[] | null) => {
    const code = parseInt(e.target.value);
    const esteira = dados ? dados.find(f => f.id === code) : esteiras.find(f => f.id === code);
    if (esteira.porcentagemRelatorioResumido < 100) {
      setCarregandoPorcentagem(true);
    } else {
      setCarregandoPorcentagem(false);
    }

    setPorcentagem(esteira.porcentagemRelatorioResumido);
    setEsteiraSelecionada(code);
    setEsteiraRealSelecionada(esteira);
  }, [esteiras]);

  const onChangeEmpresa = useCallback((e: any) => {
    const code = parseInt(e.target.value);
    setEmpresaSelecionada(code);
    setEsteiras([]);
    setCarregandoEsteiras(true);
    setPorcentagem(0);
    EmpresasService.obterEsteiras(code).then((resp) => {
      setEsteiras(resp);
      setCarregandoEsteiras(false);
      const esteiraLocal = localStorage.getItem('andamento:esteira');
      if (esteiraLocal && resp.find(f => f.id === parseInt(esteiraLocal))) {
        onChangeEsteira({ target: { value: esteiraLocal } }, resp);
      }
    });
  }, []);

  const buscarEmpresas = useCallback(async () => {
    if (!carregandoEmpresa && usuario) {
      setCarregandoEmpresa(true);
      RelatoriosService.obterEmpresasPorClienteID(usuario.clienteID || 0, (resp) => {
        setCarregandoEmpresa(false);
        setEmpresas(resp);
        const empresaLocal = localStorage.getItem('andamento:empresa');
        if (empresaLocal && resp.find(f => f.empresaID === parseInt(empresaLocal))) {
          onChangeEmpresa({ target: { value: empresaLocal } });
        }
      });
    }
  }, [carregandoEmpresa, usuario, onChangeEmpresa]);

  useEffect(() => {
    if (usuario && !iniciouCarregamentoTela) {
      setIniciouCarregamentoTela(true);
      buscarEmpresas();
    }
  }, [usuario, iniciouCarregamentoTela, buscarEmpresas]);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Acompanhamento de Resultado")}</PageTitle>
      <div className='toolbar' id='kt_toolbar'>
        <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
          <DefaultTitle />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            {carregandoEmpresa && (
              <div className='col-md-4'>
                <span className='indicator-progress' style={{ display: 'block' }}>
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  {t("Aguarde...")}
                </span>
              </div>
            )}
            {!carregandoEmpresa && (
              <div className='col-md-4 form-group'>
                {t("Empresas")}:
                <select className='form-control' disabled={carregandoEmpresa} value={empresaSelecionada} onChange={(e) => {
                  localStorage.setItem('andamento:empresa', e.target.value);
                  onChangeEmpresa(e);
                }}>
                  <option key={uniqueId()} value={0}>{t("Selecione uma empresa")}</option>
                  {empresas.map((item) => (
                    <option key={uniqueId()} value={item.empresaID}>{item.razaoSocial}</option>
                  ))}
                </select>
              </div>
            )}
            {carregandoEsteiras && (
              <div className='col-md-4'>
                <span className='indicator-progress' style={{ display: 'block' }}>
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  {t("Aguarde...")}
                </span>
              </div>
            )}
            {!carregandoEsteiras && empresaSelecionada > 0 && esteiras.length > 0 && (
              <div className='col-md-4 form-group'>
                {t("Períodos")}:
                <select className='form-control' disabled={carregandoEsteiras} value={esteiraSelecionada} onChange={(e) => {
                  localStorage.setItem('andamento:esteira', e.target.value);
                  onChangeEsteira(e, null);
                }}>
                  <option key={uniqueId()} value={0}>{t("Selecione um período")}</option>
                  {esteiras.map((item) => (
                    <option key={uniqueId()} value={item.id}>{item.periodoInicioString}-{item.periodoFimString}</option>
                  ))}
                </select>
              </div>
            )}
            {esteiraSelecionada > 0 && (
              <>
                <div className='col-md-2 mt-6'>
                  <button className='btn btn-success' onClick={() => setOpenModalResumo(true)}>{t("Análise Horizontal")}</button>
                </div>
                <div className='col-md-2 mt-6'>
                  <button className='btn btn-success' onClick={() => setOpenModalVertical(true)}>Dashboard</button>
                </div>
              </>
            )}
            {esteiraSelecionada > 0 && (
              <>
                {openModalResumo && <ModalResumo esteira={esteiraRealSelecionada} empresaID={empresaSelecionada} show={openModalResumo} esteiraID={esteiraSelecionada} toggleModal={() => setOpenModalResumo(false)} />}
                {openModalVertical && <ModalDashboardVertical show={openModalVertical} esteiraID={esteiraSelecionada} toggleModal={() => setOpenModalVertical(false)} />}
              </>

            )}
          </div>
        </div>

        {esteiraSelecionada > 0 && empresaSelecionada > 0 && !carregandoPorcentagem && esteiras.find(f => f.id === esteiraSelecionada) && (
          <div className='col-md-12 mt-3'>
            <Board empresaID={empresaSelecionada} esteira={esteiras.find(f => f.id === esteiraSelecionada)} />
          </div>
        )}

        {carregandoPorcentagem && (
          <div className='col-md-12 mt-3'>
            <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>
                  {etapaImportacao || t("O arquivo está sendo processado por nossos servidores...")}
                </span>
                <span style={{ fontSize: '16px', fontWeight: 'bold', color: porcentagem >= 100 ? '#27ae60' : '#3498db' }}>
                  {porcentagem}%
                </span>
              </div>
              <div style={{ borderRadius: '10px', width: '100%', height: '12px', backgroundColor: '#e0e0e0', overflow: 'hidden' }}>
                <div style={{
                  borderRadius: '10px',
                  width: `${porcentagem}%`,
                  height: '100%',
                  backgroundColor: porcentagem >= 100 ? '#27ae60' : porcentagem >= 50 ? '#f39c12' : '#3498db',
                  transition: 'width 0.5s ease-in-out'
                }}></div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                <span style={{ fontSize: '12px', color: '#999' }}>
                  {etapaImportacao === 'Erro na importação' ? '❌ Falha no processamento' : etapaImportacao === 'Importação concluída' ? '✅ Concluído' : '⏳ Processando...'}
                </span>
                <span
                  onClick={() => setShowDetalhesImportacao(!showDetalhesImportacao)}
                  style={{ fontSize: '12px', color: '#3498db', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  {showDetalhesImportacao ? 'Ocultar detalhes' : 'Ver detalhes'}
                </span>
              </div>
              {showDetalhesImportacao && detalhesImportacao && (
                <div style={{ fontSize: '12px', color: '#666', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px', marginTop: '8px' }}>
                  {detalhesImportacao.arquivo && <div><strong>Arquivo:</strong> {detalhesImportacao.arquivo}</div>}
                  {detalhesImportacao.inicio && <div><strong>Início:</strong> {detalhesImportacao.inicio}</div>}
                  {detalhesImportacao.usuario && <div><strong>Usuário:</strong> {detalhesImportacao.usuario}</div>}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default AndamentoContasResultado;